import React from "react";
import { Route, Redirect } from "react-router-dom";
import { interceptor } from "utils/interceptor";

export default function ProtectedRoute({ component: Component, ...rest }) {
interceptor();
  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} /> 
      }
    />
  );
}
